package nl.volleyplanner.web.controller.thuisprogramma

import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.async
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.html.ButtonType
import kotlinx.html.FlowContent
import kotlinx.html.InputType
import kotlinx.html.button
import kotlinx.html.div
import kotlinx.html.dom.create
import kotlinx.html.h6
import kotlinx.html.id
import kotlinx.html.input
import kotlinx.html.js.onClickFunction
import kotlinx.html.span
import nl.volleyplanner.api.GeneratePageTokenRequest
import nl.volleyplanner.api.PageTokenDetails
import nl.volleyplanner.web.CoroutineManager.RENDER_SCOPE
import nl.volleyplanner.web.DATE_TIME_TEXT_SHORT_NAMES
import nl.volleyplanner.web.VolleyPlannerApplication
import nl.volleyplanner.web.base.component
import nl.volleyplanner.web.base.component.BootstrapButtonStyle
import nl.volleyplanner.web.base.component.ListeningComponent
import nl.volleyplanner.web.base.component.ModalComponent
import nl.volleyplanner.web.base.component.ModalSize
import nl.volleyplanner.web.base.component.iconButton
import nl.volleyplanner.web.base.spinner
import nl.volleyplanner.web.launchAsync

class ThuisprogrammaLinkGeneratorComponent(
    val problemSlug: String
) : ModalComponent("Link thuisprogramma", ModalSize.ExtraLarge) {

    private val availableTokensFlow = MutableStateFlow<List<PageTokenDetails>?>(null)
    // TODO: need to obtain existing links to show
    private val linkFlow = MutableStateFlow<String?>(null)

    init {
        launchAsync(RENDER_SCOPE) {
            VolleyPlannerApplication.volleyplannerApiClient
                .organisation
                .pageTokens
                .listTokens(problemSlug)
        }.onComplete { tokens -> availableTokensFlow.value = tokens }
    }

    override fun FlowContent.renderBody() {
        div("mb-3") {
            button(classes = "btn btn-primary mb-3", type = ButtonType.button) {
                onClickFunction = { event ->
                    event.preventDefault()
                    launchAsync(RENDER_SCOPE) {
                        VolleyPlannerApplication.volleyplannerApiClient
                            .organisation
                            .pageTokens
                            .generateToken(GeneratePageTokenRequest(problemSlug, 180*24*60))
                    }.onComplete { token ->
                        availableTokensFlow.value = availableTokensFlow.value?.plus(token) ?: listOf(token)
                    }.onError {

                    }
                }
                +"Genereer link"
            }

            // Link display
            component(ListeningComponent("ThuisprogrammaLinkGenerator", listOf(availableTokensFlow)) {
                div {
                    if (availableTokensFlow.value == null) {
                        div { spinner() }
                    } else {
                        availableTokensFlow.value!!.forEach { token ->
                            val url = "${window.location.origin}/thuisprogramma/${token.tokenString}"
                            div(classes = "card rounded shadow-sm p-2 mb-2") {
                                h6 { +"Link geldig tot: ${DATE_TIME_TEXT_SHORT_NAMES.format(token.validUntil)}" }
                                div(classes = "d-flex") {
                                    div(classes = "flex-grow-1 rounded border border-secondary bg-secondary-subtle p-2 me-1 text-muted") {
                                        +url
                                    }
                                    iconButton(
                                        BootstrapButtonStyle.Secondary, "bi-clipboard-fill",
                                        cssClasses = setOf("ms-auto"),
                                        jsOnClickFunction = { event ->
                                            event.preventDefault()
                                            window.navigator.clipboard.writeText(url)
                                        }
                                    )
                                }
                            }
                        }
                    }
                }
            })
        }
    }
}